import type { NavItem } from "@/components/ui/navItems";

type UserLike = {
  role?: string;
} | null | undefined;

export function canAccessNavItem(
  item: NavItem,
  user: UserLike,
  isAuthenticated: boolean
) {
  const isAdmin = user?.role === "admin";
  const isCreator = user?.role === "creator";
  const isCreatorOrAdmin = isCreator || isAdmin;

  if (item.admin && !isAdmin) return false;
  if (item.creator && !isCreatorOrAdmin) return false;
  if (item.auth && !isAuthenticated) return false;

  return true;
}

export function getVisibleNavItems(
  items: NavItem[],
  user: UserLike,
  isAuthenticated: boolean
) {
  return items.filter((item) => canAccessNavItem(item, user, isAuthenticated));
}

export function getLauncherNavItems(
  items: NavItem[],
  user: UserLike,
  isAuthenticated: boolean
) {
  return items.filter((item) => {
    if (item.showInLauncher === false) return false;
    return canAccessNavItem(item, user, isAuthenticated);
  });
}